var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }